module.exports = __webpack_public_path__ + "img/OPPO@2x.67d53c8a.png";